import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import GenericConditionSectionContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionContainer"
import CustomFieldVariableChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/CustomFieldVariableChip"

type APIOutputConditionSectionContainerProps = {
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	chatBotFlowBlockId: number
}

const APIOutputConditionSectionContainer: React.FC<APIOutputConditionSectionContainerProps> = (props) => {
	const {
		chatBotFlowBlockRule,
		chatBotFlowBlockId
	} = props

	return (
		<GenericConditionSectionContainer
			chatBotFlowBlockRule={chatBotFlowBlockRule}
			customValidationRender={{
				"ai-agent-api-output": {
					firstItem: {
						render: ({ value }) => {
							const variableName = String(value).replace(/{|}/g, "")

							return (
								<CustomFieldVariableChip
									name={variableName}
									style={{
										height: 16,
										width: 160,
										borderRadius: 3,
										fontSize: 12
									}}
								/>
							)
						}
					}
				}
			}}
			chatBotFlowBlockId={chatBotFlowBlockId}
		/>
	)
}

export default APIOutputConditionSectionContainer
